/**
 * Regras do período de entrega, compartilhadas entre o cadastro de Realização
 * Destaque e o de Ação Ecoa.
 *
 * As duas páginas repetem a mesma validação; manter a regra aqui evita que uma
 * seja corrigida e a outra não.
 */

/**
 * Piso do início da entrega.
 *
 * O <input type="date"> aceita ano de 1 a 4 dígitos, então um ano digitado pela
 * metade ("0201" em vez de "2026") era gravado como epoch negativo e chegava ao
 * relatório NEC como uma data impossível.
 */
export const PERIOD_START_MIN = '2025-01-01';

/** Piso da conclusão da entrega. */
export const PERIOD_END_MIN = '2024-07-01';

/**
 * Datas em `yyyy-MM-dd` são interpretadas como meia-noite UTC, o mesmo instante
 * usado pelos limites acima — a comparação não sofre efeito de fuso.
 */
export const isPeriodStartValid = (periodStart?: string): boolean =>
  !!periodStart?.length && new Date(periodStart) >= new Date(PERIOD_START_MIN);

/**
 * `maxDate` é o último dia do mês corrente, calculado a partir da hora do servidor.
 * O início precisa existir aqui porque a conclusão só é válida se vier depois dele
 * — entrega que começa e termina no mesmo dia continua válida.
 */
export const isPeriodEndValid = (periodStart?: string, periodEnd?: string, maxDate?: string): boolean =>
  !!periodEnd?.length &&
  !!maxDate?.length &&
  !!periodStart?.length &&
  new Date(periodEnd) >= new Date(PERIOD_END_MIN) &&
  new Date(periodEnd) <= new Date(maxDate) &&
  new Date(periodStart) <= new Date(periodEnd);
